export const typography = {
  fontFamily: '"Open Sans", Arial, sans-serif',
  h1: { fontWeight: 700 },
  h2: {
    color: '#05284D',
    fontFamily: 'Open Sans',
    fontSize: '40px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '52px',
    letterSpacing: '-2.4px',
  },
  h3: { fontWeight: 500 },
  body1: { fontWeight: 400 },
  button: { textTransform: 'none' },
}
